import { PositionAdjustments } from '../constants';

export class NabcSubpunctisAndPrepunctis {
  private _letter: string;

  get letter() {
    return this._letter;
  }

  get isPrepunctus() {
    return this._letter.startsWith('pp');
  }

  get isSubpunctus() {
    return this._letter.startsWith('su');
  }

  get positionAdjustment() {
    return this.isPrepunctus ? PositionAdjustments[4] : PositionAdjustments[6];
  }

  constructor(
    letter: string,
  ) {
    this._letter = letter;
  }
}
